import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type RetentionSettingsFetchFailedAction = {
	type: 'RETENTION_SETTINGS_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): RetentionSettingsFetchFailedAction => ({
	type: 'RETENTION_SETTINGS_FETCH_FAILED',
	payload,
});
